var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1031_14988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99609 3.4978V10.4932",
    stroke: "#99A1AF",
    strokeWidth: 0.999342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.49967 8.99409C1.36715 8.99409 1.24006 8.94144 1.14635 8.84774C1.05264 8.75403 1 8.62694 1 8.49442V1.99869C1 1.86617 1.05264 1.73908 1.14635 1.64537C1.24006 1.55167 1.36715 1.49902 1.49967 1.49902H3.99803C4.52811 1.49902 5.03648 1.7096 5.41131 2.08442C5.78613 2.45925 5.99671 2.96762 5.99671 3.49771C5.99671 2.96762 6.20728 2.45925 6.58211 2.08442C6.95693 1.7096 7.46531 1.49902 7.99539 1.49902H10.4937C10.6263 1.49902 10.7534 1.55167 10.8471 1.64537C10.9408 1.73908 10.9934 1.86617 10.9934 1.99869V8.49442C10.9934 8.62694 10.9408 8.75403 10.8471 8.84774C10.7534 8.94144 10.6263 8.99409 10.4937 8.99409H7.49572C7.09816 8.99409 6.71688 9.15202 6.43576 9.43314C6.15464 9.71426 5.99671 10.0955 5.99671 10.4931C5.99671 10.0955 5.83878 9.71426 5.55766 9.43314C5.27654 9.15202 4.89526 8.99409 4.4977 8.99409H1.49967Z",
    stroke: "#99A1AF",
    strokeWidth: 0.999342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1031_14988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9921,
    height: 11.9921,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.6773a44bb386a902b1c694f3fa27f2e9.svg";
export { ForwardRef as ReactComponent };